import React from 'react';
interface ModulesProps {
  onOpenPopup: () => void;
}
const pillars = [{
  id: '01',
  title: 'Investigación del Mercado',
  description: 'Encontrá un nicho rentable y validá la demanda antes de crear.'
}, {
  id: '02',
  title: 'Creación de Producto',
  description: 'Creá tu ebook desde cero, rápido y con una oferta irresistible.'
}, {
  id: '03',
  title: 'Creación de Tienda Online',
  description: 'Montá tu tienda lista para vender y cobrar de forma automática.'
}, {
  id: '04',
  title: 'Página de Ventas',
  description: 'Estructurá una página que convierte visitas en compradores.'
}, {
  id: '05',
  title: 'Creativos',
  description: 'Diseñá anuncios y contenidos que captan la atención y venden.'
}, {
  id: '06',
  title: 'Meta Ads (Campañas Publicitarias)',
  description: 'Lanzá y escalá tus campañas en Facebook e Instagram con rentabilidad.'
}];
export function Modules({
  onOpenPopup
}: ModulesProps) {
  return <section className="py-20 bg-black border-t border-gray-900" data-id="element-79">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 uppercase tracking-wide" data-id="element-82">
            LO QUE VAS A APRENDER EN EL{' '}
            <span className="text-brand-orange" data-id="element-83">CURSO GRATIS</span>
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-84">
            Te voy a revelar pilar por pilar el{' '}
            <strong className="text-white" data-id="element-85">sistema completo</strong> con el que
            mis alumnos están haciendo{' '}
            <strong className="text-white" data-id="element-86">
              entre $2.000 y $10.000 USD de profit al mes con Ebooks
            </strong>{' '}
            —{' '}
            <em className="text-gray-400" data-id="element-87">
              el mismo que aplico yo, paso a paso.
            </em>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl mx-auto mb-12" data-id="element-88">
          {pillars.map(pillar => <div key={pillar.id} className="flex items-start p-5 bg-black border border-gray-800 rounded-lg hover:border-brand-orange/50 transition-colors group" data-id="element-89">
              <div className="flex-shrink-0" data-id="element-90">
                <span className="block text-brand-orange font-bold text-xs tracking-widest" data-id="element-91">
                  PILAR {pillar.id}
                </span>
              </div>
              <div className="self-stretch w-px bg-gray-800 mx-4 group-hover:bg-brand-orange/30 transition-colors" data-id="element-92" />
              <div data-id="element-93">
                <h3 className="text-gray-100 font-semibold text-base md:text-lg" data-id="element-94">
                  {pillar.title}
                </h3>
                <p className="text-gray-400 text-sm mt-1" data-id="element-95">
                  {pillar.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-96">
          <button onClick={onOpenPopup} className="px-8 py-4 bg-brand-orange hover:bg-red-600 text-white text-lg font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 box-glow" data-id="element-97">
            ACCEDER AL CURSO GRATIS
          </button>
        </div>
      </div>
    </section>;
}